import script from "./TitleBar.vue?vue&type=script&setup=true&lang=js"
export * from "./TitleBar.vue?vue&type=script&setup=true&lang=js"

import "./TitleBar.vue?vue&type=style&index=0&id=0a339b61&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a339b61"]])

export default __exports__